import React from 'react';

const AmazonPay = class AmazonPay extends React.Component {

  /** @type {HTMLElement|null} */
  amazonPayScriptTag = null;
  /** @type {string} */
  amazonPayForm = 'amazon_pay';

  onAmazonLoginReady = amazonPayClientID => () => {
    window.amazon.Login.setClientId(amazonPayClientID);
  };

  /**
   *
   * @returns {HTMLScriptElement}
   */
  addAmazonPayScriptTag = () => {
    const scriptAmazonPay = document.createElement('script');
    scriptAmazonPay.setAttribute(
      'src',
      'https://static-eu.payments-amazon.com/OffAmazonPayments/eur/sandbox/lpa/js/Widgets.js'
    );
    document.head.appendChild(scriptAmazonPay);
    return scriptAmazonPay;
  };

};


export default AmazonPay;
